import { FinchConnectionDetailFragment } from '@alice-financial/alice-sdk'

type ValidationResult = {
  isValid: boolean
  errorMessage: string | null
}

/**
 * Validates a connection display label for both length and uniqueness.
 * A valid label must be at least 3 characters long after trimming whitespace
 * and must not duplicate any existing connection's display label.
 *
 * @param connectionDisplayLabel - The display label to validate
 * @param allConnections - Array of all existing connections to check for duplicates
 * @returns ValidationResult object with isValid boolean and errorMessage string
 */
export const validateConnectionDisplayLabel = (
  connectionDisplayLabel: string,
  allConnections: FinchConnectionDetailFragment[]
): ValidationResult => {
  const trimmedLabel = connectionDisplayLabel.trim()

  // Check minimum length
  if (trimmedLabel.length > 0 && trimmedLabel.length < 3) {
    return {
      isValid: false,
      errorMessage: 'Account label must be at least 3 characters',
    }
  }

  // Check for duplicates (case-insensitive comparison)
  const isDuplicate = allConnections.some(
    (conn) => conn.displayLabel?.trim().toLowerCase() === trimmedLabel.toLowerCase()
  )

  if (isDuplicate) {
    return {
      isValid: false,
      errorMessage: 'This account label is already in use. Please choose a different label.',
    }
  }

  return {
    isValid: true,
    errorMessage: null,
  }
}
